export default __webpack_public_path__ + "static/media/CCCert.c43209f0.png";